import { FallbackProps } from 'react-error-boundary'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { Button, Col, Image, Layout, Row, Space, Typography } from 'antd'

import { authenticatedCustomerState } from 'src/data/customers/CustomersAtoms'
import BonLookLogo from 'src/modules/shared/BonLookLogo'
import { shopifyHomepage, shopifyHomepageStaging } from 'src/routes/NamedRoutes'
import { useErrorLogger } from 'src/utils/customHooks'
import { isMobile, isProduction } from 'src/utils/helper'

import './ErrorFallback.less'

const { Header, Content } = Layout

const HeaderSection = (): JSX.Element => {
  return (
    <Header className="default-layout__header">
      <Row justify="center">
        <Col xs={14} sm={8} className="text-centered">
          <BonLookLogo />
        </Col>
      </Row>
    </Header>
  )
}

const ErrorFallback = ({ error }: FallbackProps): JSX.Element => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const customer = useRecoilValue(authenticatedCustomerState)
  useErrorLogger(error)
  return (
    <>
      <HeaderSection />
      <Layout>
        <Content>
          <Row>
            <Col
              xs={{ order: 1, span: 24 }}
              sm={{ order: 1, span: 24 }}
              lg={{ order: 2, span: 12 }}
            >
              <Image
                preview={false}
                width="100%"
                src={`${process.env.PUBLIC_URL}/images/${
                  isMobile() ? 'mobile' : 'desktop'
                }_404page_image.jpg`}
              />
            </Col>
            <Col
              xs={{ order: 2, span: 24 }}
              sm={{ order: 2, span: 24 }}
              lg={{ order: 1, span: 12 }}
              className="error-fallback__text-section"
            >
              <Row justify="center" align="middle">
                <Col span={18}>
                  <Space direction="vertical">
                    <Typography.Title className="font-lora error-fallback__title">
                      {t('common:errors.title')}
                    </Typography.Title>
                    <Trans t={t} i18nKey="common:errors.text">
                      <Button
                        type="text"
                        onClick={() => navigate(-1)}
                        className="error-fallback__back-btn"
                      >
                        nothing to see here
                      </Button>
                      <a
                        className="error-fallback__external-link"
                        href={!isProduction() ? shopifyHomepageStaging(customer.language) : shopifyHomepage(
                          customer.country,
                          customer.language
                        )}
                      >
                        nothing to see here
                      </a>
                    </Trans>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  )
}

export default ErrorFallback
